<mdc-dialog-title>
    Upload some Models:
</mdc-dialog-title>
<mdc-dialog-content>
    <div  id="dragdropModel" ></div>
</mdc-dialog-content>
<mdc-dialog-actions>
    <button mdc-button data-mdc-dialog-action="ok" click.trigger="loadLocal()">Load local</button>
    <button disabled mdc-button data-mdc-dialog-action="ok" click.trigger="loadToDatabase()">Load to database</button>
</mdc-dialog-actions>